export default {"src":"/_next/static/media/member-taking-medication-tobacco.mono.9c2d5f12.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};